import DOMPurify from 'dompurify';

/**
 * Sanitizes HTML content to prevent XSS attacks
 */
export const sanitizeContent = (content: string): string => {
  return DOMPurify.sanitize(content, {
    ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 'i', 'b'],
    ALLOWED_ATTR: [],
    KEEP_CONTENT: true,
  });
};

/**
 * Validates comment content
 */
export const validateComment = (content: string): { isValid: boolean; error?: string } => {
  const trimmed = content.trim();
  
  if (!trimmed) {
    return { isValid: false, error: 'Comment cannot be empty' };
  }
  
  if (trimmed.length > 2000) {
    return { isValid: false, error: 'Comment must be less than 2000 characters' };
  }
  
  if (trimmed.length < 3) {
    return { isValid: false, error: 'Comment must be at least 3 characters long' };
  }
  
  // Check for potential spam patterns
  const spamPatterns = [
    /(.)\1{20,}/, // Repeated characters
    /^[A-Z\s!]{50,}$/, // All caps with excessive length
    /(https?:\/\/[^\s]+)/gi, // URLs (basic detection)
  ];
  
  for (const pattern of spamPatterns) {
    if (pattern.test(trimmed)) {
      return { isValid: false, error: 'Comment appears to be spam or contains inappropriate content' };
    }
  }
  
  return { isValid: true };
};